import { layout } from "./layout";
import { popup } from "./popup";
import { tokens } from "./tokens";

/** Complete stylesheet injected into the widget's shadow root. */
export const styles = tokens + layout + popup;
